import { downloadICSFile } from '../utils/calendar';

export default function SuccessMessage({ onReset, confirmationData }) {
    const handleAddToCalendar = () => {
        downloadICSFile();
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-lg shadow-2xl p-8 text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-amber-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                    {confirmationData?.success ? 'Thank You! நன்றி!' : 'Confirmation'}
                </h2>
                <p className="text-gray-600 mb-4">
                    {confirmationData?.message || 'Your RSVP has been successfully received!'}
                </p>

                {confirmationData?.confirmation && (
                    <div className="bg-amber-50 border-2 border-amber-200 p-4 rounded-lg mb-6 text-left">
                        <p className="text-sm font-bold text-amber-800 mb-3 text-center">📋 Your Confirmation</p>
                        <div className="space-y-2">
                            {confirmationData.confirmation.confirmationNumber && (
                                <div className="flex justify-between text-sm">
                                    <span className="text-gray-600">Confirmation #:</span>
                                    <span className="font-semibold text-gray-800">{confirmationData.confirmation.confirmationNumber}</span>
                                </div>
                            )}
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Name:</span>
                                <span className="font-semibold text-gray-800">{confirmationData.confirmation.name}</span>
                            </div>
                            {confirmationData.confirmation.totalGuests && (
                                <div className="flex justify-between text-sm">
                                    <span className="text-gray-600">Total People:</span>
                                    <span className="font-semibold text-gray-800">{confirmationData.confirmation.totalGuests}</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {confirmationData?.event && (
                    <div className="bg-blue-50 border-2 border-blue-200 p-4 rounded-lg mb-6">
                        <p className="text-sm font-bold text-blue-800 mb-3 text-center">📅 Event Details</p>
                        <div className="space-y-2 text-sm mb-4 text-left">
                            <div className="flex justify-between">
                                <span className="text-gray-600">Date:</span>
                                <span className="font-semibold text-gray-800">{confirmationData.event.date}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-gray-600">Time:</span>
                                <span className="font-semibold text-gray-800">{confirmationData.event.time}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-gray-600">Venue:</span>
                                <span className="font-semibold text-gray-800 text-right ml-2">{confirmationData.event.venue}</span>
                            </div>
                        </div>

                        <button
                            onClick={handleAddToCalendar}
                            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 px-4 rounded-lg font-bold transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-3 text-base"
                        >
                            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM5 8V6h14v2H5zm2 4h10v2H7v-2zm0 4h7v2H7v-2z"/>
                            </svg>
                            Add to Calendar
                        </button>

                        <p className="text-xs text-gray-500 text-center mt-3">
                            Opens automatically in your default calendar app
                        </p>
                    </div>
                )}

                <p className="text-xs text-gray-500 mb-6">
                    We look forward to celebrating this special occasion with you!
                </p>

                <button
                    onClick={onReset}
                    className="bg-gradient-to-r from-amber-500 to-orange-600 text-white px-6 py-2 rounded-lg hover:from-amber-600 hover:to-orange-700 transition-all"
                >
                    Submit Another RSVP
                </button>
            </div>
        </div>
    );
}